import PropTypes from 'prop-types';

const CoinSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 40}`}
      height={`${height || 40}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M16.6526 29.9667C24.0072 29.9667 29.9693 24.0046 29.9693 16.65C29.9693 9.29542 24.0072 3.33334 16.6526 3.33334C9.29801 3.33334 3.33594 9.29542 3.33594 16.65C3.33594 24.0046 9.29801 29.9667 16.6526 29.9667Z"
        fill={color}
      />
      <path
        d="M36.6187 26.65C36.6187 32.15 32.1521 36.6167 26.6521 36.6167C23.2521 36.6167 20.2687 34.9167 18.4688 32.3333C25.7354 31.5167 31.5187 25.7333 32.3354 18.4667C34.9187 20.2667 36.6187 23.25 36.6187 26.65Z"
        fill={color}
      />
      <path
        d="M19.0859 16.1833L15.0859 14.7833C14.6859 14.65 14.6026 14.6167 14.6026 14.0333C14.6026 13.6 14.9026 13.25 15.2859 13.25H17.7859C18.3193 13.25 18.7526 13.7333 18.7526 14.3333C18.7526 15.0167 19.3193 15.5833 20.0026 15.5833C20.6859 15.5833 21.2526 15.0167 21.2526 14.3333C21.2526 12.4167 19.7693 10.85 17.9193 10.7667V10.6833C17.9193 9.99999 17.3526 9.43332 16.6693 9.43332C15.9859 9.43332 15.4193 9.98332 15.4193 10.6833V10.7667H15.2693C13.5193 10.7667 12.0859 12.2333 12.0859 14.05C12.0859 15.6333 12.7859 16.65 14.2359 17.15L18.2526 18.55C18.6526 18.6833 18.7359 18.7167 18.7359 19.3C18.7359 19.7333 18.4359 20.0833 18.0526 20.0833H15.5526C15.0193 20.0833 14.5859 19.6 14.5859 19C14.5859 18.3167 14.0193 17.75 13.3359 17.75C12.6526 17.75 12.0859 18.3167 12.0859 19C12.0859 20.9167 13.5693 22.4833 15.4193 22.5667V22.6667C15.4193 23.35 15.9859 23.9167 16.6693 23.9167C17.3526 23.9167 17.9193 23.35 17.9193 22.6667V22.5833H18.0693C19.8193 22.5833 21.2526 21.1167 21.2526 19.3C21.2526 17.7167 20.5359 16.7 19.0859 16.1833Z"
        fill={color}
      />
    </svg>
  );
};

CoinSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default CoinSvg;
